import { useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ButtonBase from "@mui/material/ButtonBase";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grow from "@mui/material/Grow";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft as iconBack } from "@fortawesome/pro-regular-svg-icons";
import { faArrowRight as iconNext } from "@fortawesome/pro-regular-svg-icons";
import { faUpRightFromSquare as iconPopLink } from "@fortawesome/pro-duotone-svg-icons";

import { scrollSnapTop } from "services/tools";

import configEntzy from "components/config/ConfigEntzy";

import "./AboutCards.css";

function AboutCards(props) {
  const createSteps = props.createSteps;

  const [stepId, setStepId] = useState(props.stepId ? props.stepId : 0);

  const handleStep = (nextStepId) => {
    setStepId(nextStepId);
    scrollSnapTop();
  };

  const steps = createSteps({
    handleStep,
  });
  const activeIndex = steps.findIndex((step) => step.id === stepId);
  const activeStep = steps[activeIndex] || steps[0];
  const previousStep = steps[activeIndex - 1];
  const nextStep = steps[activeIndex + 1];

  return (
    <Box className="about-cards">
      <Container maxWidth="lg" disableGutters>
        <Box className="about-cards-shell">
          <Box className="about-cards-trail">
            {steps.map((step) => (
              <ButtonBase
                key={step.id}
                className={
                  step.id === activeStep.id
                    ? "about-cards-crumb is-active"
                    : "about-cards-crumb"
                }
                onClick={() => handleStep(step.id)}
              >
                {step.breadcrumb}
              </ButtonBase>
            ))}
          </Box>

          <Grow key={activeStep.id} in={stepId === activeStep.id} timeout={500}>
            <Box className="about-cards-grid">
              <Box
                className="about-cards-image"
                sx={{
                  backgroundImage: `url(${activeStep.image})`,
                }}
              >
                <Box className="about-cards-imageText">
                  <Typography variant="subtitle2">
                    {activeStep.eyebrow}
                  </Typography>
                  <Typography variant="h3">{activeStep.heroTitle}</Typography>
                  <Typography variant="h6">{activeStep.subtitle}</Typography>
                </Box>
              </Box>

              <Box className="about-cards-content">
                <Box className="about-cards-heading">
                  <FontAwesomeIcon icon={activeStep.icon} />
                  <Box>
                    <Typography variant="subtitle2">
                      {activeStep.title}
                    </Typography>
                    <Typography variant="h4">{activeStep.bodyTitle}</Typography>
                  </Box>
                </Box>

                <Box className="about-cards-text">
                  {activeStep.textList.map((text, index) => (
                    <Typography variant="body1" key={index}>
                      {text}
                    </Typography>
                  ))}
                </Box>

                <Box className="about-cards-text">
                  {activeStep.linkList &&
                    activeStep.linkList.map((link, index) => (
                      <Typography
                        key={index}
                        variant="subtitle2"
                        color="primary"
                        sx={{ mt: configEntzy.APP_SPACING_MD }}
                      >
                        <a
                          href={link.href}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FontAwesomeIcon icon={iconPopLink} />
                          <span>&nbsp;&nbsp;</span>
                          <span>{link.label}</span>
                        </a>
                      </Typography>
                    ))}
                </Box>

                <Box className="about-cards-actions">
                  {previousStep && (
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handleStep(previousStep.id)}
                      startIcon={<FontAwesomeIcon icon={iconBack} />}
                    >
                      Back
                    </Button>
                  )}
                  {activeStep.secondaryAction && (
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={activeStep.secondaryAction.onClick}
                    >
                      {activeStep.secondaryAction.label}
                    </Button>
                  )}
                  {activeStep.primaryAction ? (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={activeStep.primaryAction.onClick}
                      endIcon={<FontAwesomeIcon icon={iconNext} />}
                    >
                      {activeStep.primaryAction.label}
                    </Button>
                  ) : nextStep ? (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleStep(nextStep.id)}
                      endIcon={<FontAwesomeIcon icon={iconNext} />}
                    >
                      Next
                    </Button>
                  ) : null}
                </Box>
              </Box>
            </Box>
          </Grow>
        </Box>
      </Container>
    </Box>
  );
}

export default AboutCards;
